module.exports = __webpack_public_path__ + "static/img/5.ed952b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/eng/5.png
// module id = aYtj
// module chunks = 0